import React, { Component } from 'react'

import HeaderAvatar from './HeaderAvatar'

export default class Header extends Component {
  render() {
    const { me } = this.props;
    return (
      <div className='app-header md-top-bar'>
        <div className='md-top-bar-inner'>
          <a
            data-toggle='modal'
            data-target='#aside'
            className='md-mobile-menu-btn d-lg-none'
          >
            <span className='md-nav-icon'>menu</span>
          </a>
          <div className='md-top-bar-company'>
            {me && me.company && me.company.name}
          </div>
          <div className='md-top-bar-actions'>
            {me && <HeaderAvatar />}
          </div>
        </div>
      </div>
    )
  }
}
